<template>
  <div class="main-view">
    <!-- RegForm.patientType={{patientType}} -->
    <RegistrationForm :isNewPatient="patientType=='new'" />
  </div>
</template>

<script>
// @ is an alias to /src
import RegistrationForm from '@/components/RegistrationForm.vue';
import {debug} from '@/components/globals.js';

export default {
  name: 'Home',

  components: {
    RegistrationForm
  },

  props: {
    patientType: String
  },

  mounted() {
    debug('Main mounted')
  }
}
</script>
